import { render, staticRenderFns } from "./ProfileAbout.vue?vue&type=template&id=5c74d382&"
import script from "./ProfileAbout.vue?vue&type=script&lang=js&"
export * from "./ProfileAbout.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAbout.vue?vue&type=style&index=0&id=5c74d382&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports